// reducer for ui state

import { createSlice } from '@reduxjs/toolkit';

export interface Toast {
    title: string;
    description: string;
}

interface UiState {
    toast: Toast | null;
    modal: string | null;
}

const initialState: UiState = {
    toast: null,
    modal: null,
}

const uiSlice = createSlice({
    name: 'ui',
    initialState: initialState,
    reducers: {
        setToast: (state, action) => {
            state.toast = action.payload;
        },
        setModal: (state, action) => {
            state.modal = action.payload;
        }
    }
});

export const { setToast, setModal } = uiSlice.actions;
export default uiSlice.reducer;